import React from 'react';
import './style.css';

// Helper function to map card string to image path
const getCardImage = (cardString) => {
  if (!cardString) return null;
  const match = cardString.match(/^([A-Z0-9]+)([A-Z])\2?$/);
  if (match) {
    const value = match[1];
    const suit = match[2];
    const cleanCard = `${value}${suit}`;
    return `/assets/img/cards/${cleanCard}.png`;
  }
  return `/assets/img/cards/${cardString}.png`;
};

// Parse 9 cards: Player A (2 cards), Player B (2 cards), Board (5 cards)
const parseCards = (cardString) => {
  if (!cardString) return { playerA: [], playerB: [], board: [] };
  const cards = cardString.split(',').map(c => c.trim());
  
  return {
    playerA: cards.slice(0, 2).map(c => getCardImage(c)),
    playerB: cards.slice(2, 4).map(c => getCardImage(c)),
    board: cards.slice(4, 9).map(c => getCardImage(c)),
  };
};

// Parse rdesc
const parseRdesc = (rdesc) => {
  if (!rdesc) return { winner: "", playerA: "", playerB: "" };
  const parts = rdesc.split('#');
  
  return {
    winner: parts[0] || "",
    playerA: parts[1] || "",
    playerB: parts[2] || "",
  };
};

const Poker = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const cards = detailResult?.card ? parseCards(detailResult.card) : { playerA: [], playerB: [], board: [] };
  const rdescData = detailResult?.rdesc ? parseRdesc(detailResult.rdesc) : {};
  const winner = detailResult?.winnat || rdescData.winner || "";
  const winValue = detailResult?.win;
  const isPlayerAWinner = winValue === "1" || winner === "Player A";
  const isPlayerBWinner = winValue === "2" || winner === "Player B";

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <h6 className="text-right">
            <b>Round Id :</b> {roundId}
          </h6>
        </div>
      </div>

      <div className="row player-container m-t-10">
        <div className="col-md-12">
          <div className="player-image-container" style={{ display: 'flex', flexDirection: 'row', gap: '0' }}>
            {/* Player A */}
            <div className="text-center player-number" style={{ flex: '1' }}>
              <h4>Player A</h4>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '5px' }}>
                {cards.playerA?.map((card, idx) => (
                  card && (
                    <img
                      key={idx}
                      src={card}
                      alt={`Player A Card ${idx + 1}`}
                      onError={(e) => {
                        const cardName = card.split('/').pop();
                        const fallbackPath = `/assets/img/cards/${cardName}`;
                        if (e.target.src !== fallbackPath) {
                          e.target.src = fallbackPath;
                        } else {
                          e.target.style.display = 'none';
                        }
                      }}
                    />
                  )
                ))}
              </div>
              <div className="text-center">
                {isPlayerAWinner ? (
                  <label className="winner-label bg-success m-t-20">
                    <i className="fas fa-trophy m-r-5"></i> Winner
                  </label>
                ) : (
                  <label className="m-t-20">&nbsp;</label>
                )}
              </div>
            </div>

            {/* Player B */}
            <div className="text-center player-number" style={{ flex: '1' }}>
              <h4>Player B</h4>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '5px' }}>
                {cards.playerB?.map((card, idx) => (
                  card && (
                    <img
                      key={idx}
                      src={card}
                      alt={`Player B Card ${idx + 1}`}
                      onError={(e) => {
                        const cardName = card.split('/').pop();
                        const fallbackPath = `/assets/img/cards/${cardName}`;
                        if (e.target.src !== fallbackPath) {
                          e.target.src = fallbackPath;
                        } else {
                          e.target.style.display = 'none';
                        }
                      }}
                    />
                  )
                ))}
              </div>
              <div className="text-center">
                {isPlayerBWinner ? (
                  <label className="winner-label bg-success m-t-20">
                    <i className="fas fa-trophy m-r-5"></i> Winner
                  </label>
                ) : (
                  <label className="m-t-20">&nbsp;</label>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Cards */}
      <div className="row m-t-10 text-center">
        <div className="col-md-12 player-number">
          <div className="player-image-container" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '5px' }}>
            {cards.board?.map((card, idx) => (
              card && (
                <img
                  key={idx}
                  src={card}
                  alt={`Table Card ${idx + 1}`}
                  onError={(e) => {
                    const cardName = card.split('/').pop();
                    const fallbackPath = `/assets/img/cards/${cardName}`;
                    if (e.target.src !== fallbackPath) {
                      e.target.src = fallbackPath;
                    } else {
                      e.target.style.display = 'none';
                    }
                  }}
                />
              )
            ))}
          </div>
        </div>
      </div>

      {/* Result Details */}
      <div className="row board-result m-t-10">
        <div className="col-md-12">
          <div className="board-result-inner">
            {winner && (
              <div className="m-b-5">
                <span className="greenbx">Winner: </span>
                {winner}
              </div>
            )}
            {rdescData.playerA && (
              <div className="m-b-5">
                <span className="redbx">2 Card: </span>
                {rdescData.playerA}
              </div>
            )}
            {rdescData.playerB && (
              <div className="m-b-5">
                <span className="yellowbx">7 Card: </span>
                {rdescData.playerB}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Poker;

